import { render, staticRenderFns } from "./CrmList.vue?vue&type=template&id=16f7b6cc&scoped=true&"
import script from "./CrmList.vue?vue&type=script&lang=js&"
export * from "./CrmList.vue?vue&type=script&lang=js&"
import style0 from "./CrmList.vue?vue&type=style&index=0&id=16f7b6cc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16f7b6cc",
  null
  
)

export default component.exports